import { createFrontendModule } from '@backstage/frontend-plugin-api';
import searchPlugin from '@backstage/plugin-search/alpha';
import { searchMessages, searchReactMessages } from './translations';

/**
 * Search with the Busca page of the v2 design (Story 5.3, AC-12): only the
 * page loader is replaced; the route and the `noTrack` setting stay the
 * plugin's. The page title ("Busca") is set in app-config.yaml.
 */
export const byxSearchPlugin = searchPlugin.withOverrides({
  extensions: [
    searchPlugin.getExtension('page:search').override({
      factory: (originalFactory, { config }) =>
        originalFactory({
          params: {
            loader: async () => {
              const { ByxSearchPage } = await import('./ByxSearchPage');
              return <ByxSearchPage noTrack={config.noTrack} />;
            },
          },
        }),
    }),
  ],
});

/**
 * pt-BR texts of the search plugins. The app's translations input only
 * accepts extensions of the app plugin itself.
 */
export const searchTranslationsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [searchMessages, searchReactMessages],
});
